import React from "react";
import { FaqMarkdownPage } from "../../components/FaqMarkdownPage";

// Routed at /faq/search — content lives entirely in
// public/locales/faq/search-overview.*.md, editable without touching this file.
export const SearchFaqPage: React.FC = () => (
    <FaqMarkdownPage
        titleKey="FAQ_SEARCH_TITLE"
        titleFallback="Search — Finding People by Name, Technology & Certificate"
        markdownBasePath="/locales/faq/search-overview"
    />
);
